"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./BaseFloatingPicker"), exports);
tslib_1.__exportStar(require("./PeoplePicker/FloatingPeoplePicker"), exports);
tslib_1.__exportStar(require("./Suggestions/SuggestionsStore"), exports);
tslib_1.__exportStar(require("./Suggestions/SuggestionsControl"), exports);
tslib_1.__exportStar(require("./Suggestions/SuggestionsCore"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/FloatingPicker/index.js
// module id = 986
// module chunks = 0